import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { resourceAdaptor } from 'qp-adaptor';
import { Resource, ServiceResponse } from 'qp-ui-interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../shared/services/config.service';
import { StorefrontPolicyService } from '../shared/services/firstlight/storefront-policy/storefront-policy.service';
import { SessionStorageService } from '../shared/services/storage/session-storage.service';
import { AppConfig } from '../shared/utils/constants/app-config.constant';
import { getDeviceType } from '../shared/utils/deviceUtils';

@Injectable()
export class StorefrontHttpService {
  private readonly applicationConfig: AppConfig;

  constructor(
    private readonly configService: ConfigService,
    private readonly httpClient: HttpClient,
    private readonly policyService: StorefrontPolicyService
  ) {
    this.applicationConfig = this.configService.applicationConfig;
  }

  getDataFromContentURL(
    contentURL: string,
    isHeader: boolean,
    sessionstorage: SessionStorageService,
    disableMap?: boolean
  ): Observable<any> {
    if (contentURL === undefined) {
      return new Observable<any>((observer) => {
        observer.next();
        observer.complete();
      });
    }
    const policy = this.policyService.getPolicy();

    const headers = new HttpHeaders({
      authorization: `Bearer ${sessionstorage.getItem('authData')}`,
    });

    return this.httpClient
      .get(
        `${contentURL}&reg=${policy.reg}&acl=${policy.acl}&dt=${policy.dt}&pf=${policy.pf}`,
        isHeader ? { headers } : undefined
      )
      .pipe(
        map((item) => {
          const serviceResponse = item as ServiceResponse<Resource[]>;
          let resources;
          if (!disableMap) {
            resources = serviceResponse.data?.map((resource) => {
              return resourceAdaptor(
                this.applicationConfig.imageResizeURL,
                resource,
                getDeviceType(),
                undefined,
                //this.newrelicStore.getApplicationInfo().appVersion,
                undefined, // Container
                undefined, // Card Size
                undefined
              );
            });
          } else {
            resources = serviceResponse.data;
          }
          return {
            header: serviceResponse.header,
            data: resources,
          };
        })
      );
  }
}
